export default {
  privateSubtitle: 'Do you want to send invites for this service order?',
  publicSubtitle: 'Share this link with whoever you wanto to reply to this service order',
  cancel: 'Not now',
  sendForm: 'Send service order',
  shareLink: 'Sharing link'
}
